import React from 'react';

export default function PriorityIcon(props:any) {

    let priorityClass;

    switch (props.priority) {
        case 100: priorityClass = 'pr-emergency'; break;
        case 50 : priorityClass = 'pr-blocker'; break;
        case 10 :
        case 9  : priorityClass = 'pr-6'; break;
        case 8  :
        case 7  : priorityClass = 'pr-5'; break;
        case 6  : priorityClass = 'pr-4'; break;
        case 5  : priorityClass = 'pr-3'; break;
        case 4  :
        case 3  : priorityClass = 'pr-2'; break;
        case 2  : priorityClass = 'pr-1'; break;
        case 1  : priorityClass = 'pr-0'; break;

        default:
            console.red("#9de87373 How come? Incorrect Priority value! priority=", props.priority)
            priorityClass = 'pr-3';
            break;
            // return <div>PRIORITY ICON</div>;
    }

    return <div className={Classes("ui5-priority", priorityClass, props.className)}/>;
};